import { Icon, Steps } from "@chakra-ui/react";
import useThemeColors from "../../../hooks/useThemeColors";
import useIcons from "../../../hooks/useIcons";
import { IconType } from "react-icons";
import { useBreakPoint } from "../../../hooks/useBreakPoint";

interface Props {
  activeStep: number;
  steps: { title: string; description: string; icon: IconType }[];
}

function RegistrationStepper({ activeStep, steps }: Props) {
  const colors = useThemeColors();
  const icons = useIcons();
  const { isMobile } = useBreakPoint();

  return (
    <Steps.Root
      step={activeStep}
      size={"xs"}
      w={"600px"}
      colorPalette={colors.brand.primary}
    >
      <Steps.List>
        {steps.map((step, index) => (
          <Steps.Item key={index} index={index} title={step.title}>
            <Steps.Indicator>
              <Steps.Status
                complete={<Icon as={icons.utility.check} />}
                incomplete={<Icon as={step.icon} />}
              />
            </Steps.Indicator>
            {!isMobile && (
              <Steps.Title fontSize={"xs"}>{step.title}</Steps.Title>
            )}
            <Steps.Separator />
          </Steps.Item>
        ))}
      </Steps.List>
    </Steps.Root>
  );
}

export default RegistrationStepper;
